export default __webpack_public_path__ + "static/media/img6.3a78b5ec.jpeg";